import Cookies from 'js-cookie'
import myAxios from 'service/axios'
import { USER_TOKEN_COOKIE_NAME } from 'config'

// Redux store
import type { Dispatch } from 'react'
import type { AnyAction } from '@reduxjs/toolkit'
import { changeLoading, userAuth } from 'store/store'

export default async function checkTokenValidity(dispatch: Dispatch<AnyAction>, changeLoader: (param: boolean) => void) {
  try {
    dispatch(changeLoading(true))

    const response = await myAxios.get('/users/userme')

    dispatch(
      userAuth({
        data: { ...response?.data, access_token: response?.data?.access_token || Cookies.get(USER_TOKEN_COOKIE_NAME) || '' },
        type: 'LOGIN',
      }),
    )
  } catch {
    dispatch(userAuth({ data: null, type: 'LOGOUT' }))
  } finally {
    changeLoader(false)
    dispatch(changeLoading(false))
  }
}